import { domain, clientId } from '../auth_config.json';

export const environment = {
  production: true,
  urlType:"PROD",
  //urlType:"LOCAL",
  moralisAppId:"",
  moralisUrl:"",
  //endpoint:"http://localhost:5000",
  //base:"http://localhost:8546/",
  endpoint:"https://yinygang.xyz",
  prod:"https://operations.yygang.io",
  //prod:"http://localhost:8546",
  token:"jdjaosiij28892SIAHI049923701CIGknlklajal",
  discordauth:"https://discord.com/api/oauth2/authorize",
  discordClient:"948783641348161536",
  siteKey:"6LeWI7IeAAAAAFKUA8VrkIOuhV-8Qc0A2DhlymRf",
  //yyg:"0x968b6210CAFB39DdF70d08AfDBf092B35542F25c",
  //yyg:'0xa6d4409BF958498879D0cF1549A133b93e4F4B32',
  //elder:"0x943f4f7fc2D48F3AD8C524cf8A8794B64100df3F",
  //dysto:"0x648E8428e0104Ec7D08667866a3568a72Fe3898F",
  //packManager:"0xA1a964c0a30893a0283c2A94d6dfe58eBA5e8129",
  //pack:"0xD38572f79dAB4835b36407e85489Ed2284eAd81E",
  //stakingContract:"0x71fa196ac9522f2ca8b50a7ab8c5a4e0fef75866"
  yyg:'0x968b6210CAFB39DdF70d08AfDBf092B35542F25c',
  elder:"0x943f4f7fc2D48F3AD8C524cf8A8794B64100df3F",
  dysto:"0x648E8428e0104Ec7D08667866a3568a72Fe3898F",
  packManager:"0xdbA96658a6d4511B975aee2B83c99c3321200d5f",
  pack:"0x2f5B22a068fA534c520C94BE3f199091B2d1CD97",
  mintPrice:.05,
  scPrice:500
};
